
















































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { getDefaultAloPersonne } from '@/models/alo/AloPersonne'
import * as rules from '@/utils/validationRules'

@Component({
  name: 'GestionPersonne',  
})
export default class GestionPersonne extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newPersonne = getDefaultAloPersonne()
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }
 

  private get personne() {
    return this.$store.myGetters.personneList
  }

  private get search(){
    return this.$store.myGetters.searchPersonne
  }

  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_PERSONNE(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortPersonneDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_PERSONNE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortPersonneBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_PERSONNE_BY(value)
  }

  private headers = [
    { text: 'ID', value: 'id', width:"80" },
    { text: 'Enseigne', value: 'ensId', width:"110" },    
    { text: 'Nom', value: 'prsNom'},
    { text: 'Prénom', value: 'prsPrenom'},    
    { text: 'Login', value: 'usr.usrLogin', width:"150"},
    { text: 'Level', value: 'usr.usrRole', width:"110"},
    { text: 'Portail', value: 'usr.usrIsDisabled', width:"90"},
    { text: 'Dernier accès', value: 'usr.usrDatlogin', width:"150"},
  ]

  created() {
    this.loading = true  
    this.$store.myActions.CATALOGUE_REFERENCE_ENSURE().then(()=> {
      this.$store.myActions.ADM_PERSONNE_ENSURE().finally(() => {
        this.loading = false
      })
    }).catch(()=>{
      this.loading = false
    })
  }

  get enseignes(){
    return this.$store.myGetters.enseignes
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyPersonne',params:{personneId:item.id}})    
  }

  addPersonne() {
    this.showNew = true  
    this.newPersonne = {...getDefaultAloPersonne(),ensId:this.$store.myGetters.userProfile.ensId}
  }

  save(){
    if ((this.$refs.newPersonneForm as HTMLFormElement).validate()) {    
      this.$store.myActions.ADM_PERSONNE_SAVE_REQUEST(this.newPersonne).then((personne) => {
        this.showNew = false
        this.openDetail(personne)
      })    
    }
  }
}
